import { render, staticRenderFns } from "./RegisterPageStep2.vue?vue&type=template&id=412736bf&scoped=true&"
import script from "./RegisterPageStep2.vue?vue&type=script&lang=js&"
export * from "./RegisterPageStep2.vue?vue&type=script&lang=js&"
import style0 from "./RegisterPageStep2.vue?vue&type=style&index=0&id=412736bf&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "412736bf",
  null
  
)

export default component.exports